export default "__VITE_ASSET__BctqI8VY__"